import { Observable } from 'rxjs';
import {
  Utente,
  CreateDipendenteDto,
  DipendentiQueryParams,
  DipendentiPage,
  UpdateDatiAziendaDto, DatiAziendaDto
} from '../../models/utente.mdoel';
import {
  CreateExtraDto,
  CreateIncassoDto,
  Extra,
  Incasso,
  UpdateExtraDto,
  UpdateIncassoDto
} from '../../models/capitoli.model';

export abstract class DipendentiPort {
  abstract getListPaginated(params: DipendentiQueryParams): Observable<DipendentiPage>;
  abstract getById(id: number): Observable<Utente>;
  abstract create(dto: CreateDipendenteDto): Observable<void>;

  abstract update(id: number, dto: CreateDipendenteDto): Observable<void>;
  abstract archive(id: number, archive: boolean): Observable<void>;

  abstract getDatiAzienda(id: number): Observable<DatiAziendaDto>;

  abstract updateDatiAzienda(
    id: number,
    dto: UpdateDatiAziendaDto
  ): Observable<number>;

  abstract uploadLogoDatiAzienda(
    id: number,
    file: File
  ): Observable<number>;
}
